/** Shared stateless projection of the existing sheet class-level icon loop. */
export interface ClassLevelIconReaders {
    field(key: string): unknown;
    id(key: string): string;
    escape(value: string): string;
    icon(id: string, size: number): string;
    attrs(id: string): string;
}
export function renderClassLevelIcons(read: ClassLevelIconReaders, size = 50): string {
    let html = '';
    for (let slot = 1; slot <= 20; slot++) {
        const level = read.field(`class_level_${slot}`);
        if (level === undefined || level === null || String(level) === '') continue;
        const id = read.id(`subclass_${slot}`) || read.id(`class_${slot}`);
        if (!id) continue;
        html += `<span class="position-relative" role="button" ${read.attrs(id)}><span class="position-absolute top-0 start-100 translate-middle badge border rounded-pill bg-success">${read.escape(String(level))}</span>${read.icon(id, size)}</span>`;
    }
    return html;
}
